import React from "react";
import { Tooltip } from "antd";
import { ColumnsType } from "antd/lib/table";
import { Trash, Pencil } from "assets/icons";
import useTranslation from "utils/hooks/useTranslation";
import * as S from "./styled/index.styled";

interface ICollum {
  key: string;
  title: string;
  dataIndex: string;
  sorter: any;
  filterMultiple: boolean;
  width: string;
  render: (...args) => JSX.Element | string;
}

const ColumnsTable = ({ handleClick, handleClickEdit, isAdmin }) => {
  const PROCESSES = useTranslation({ id: "processes" });
  const DOCUMENT = useTranslation({ id: "document" });
  const ACTIONS = useTranslation({ id: "actions" });
  const EDIT_PROCESS = useTranslation({ id: "edit_process" });
  const DELETE_PROCESS = useTranslation({ id: "delete_process" });
  const collums: Array<ICollum> = [
    {
      title: PROCESSES,
      sorter: (a: any, b: any) => {
        a = a.description || "";
        b = b.description || "";
        return a.localeCompare(b);
      },
      key: "description",
      filterMultiple: false,
      width: "47%",
      dataIndex: "description",
      render: (description: string) => (description === undefined ? "--" : description),
    },
    {
      title: DOCUMENT,
      dataIndex: "documents",
      sorter: false,
      filterMultiple: false,
      render: (documents: ColumnsType<string>) => (documents === undefined || documents?.length === 0 ? "--" : <div>{documents.join(", ")}</div>),
      width: "47%",
      key: "documents",
    },
  ];

  const actionCollum = {
    title: ACTIONS,
    width: "6%",
    dataIndex: "action",
    key: "actions",
    filterMultiple: false,
    sorter: false,
    render: (_, record) => (
      <S.ActionContainer>
        <button onClick={() => handleClickEdit(record)} data-testid="editItem">
          <Tooltip placement="top" title={EDIT_PROCESS}>
            <Pencil className="pencilEdit" data-testid="edit-process-icon" />
          </Tooltip>
        </button>
        <button onClick={() => handleClick(record)} data-testid="deleteItem">
          <Tooltip placement="top" title={DELETE_PROCESS}>
            <Trash className="trashIcon" data-testid="delete-process-icon" />
          </Tooltip>
        </button>
      </S.ActionContainer>
    ),
  };

  if (isAdmin) {
    collums.push(actionCollum);
  }

  return collums;
};

export default ColumnsTable;
